import gql from 'graphql-tag';

export const CREATOR_DISCOVERY_EMAIL_RESOURCE_FRAGMENT = gql`
  fragment CreatorDiscoveryEmailResourceFragment on CreatorDiscoveryEmailResource {
    id
    email
    provider
  }
`;

export const CREATOR_DISCOVERY_EMAIL_SETTINGS_FRAGMENT = gql`
  fragment CreatorDiscoveryEmailSettingsFragment on CreatorDiscoveryEmailSettings {
    resources {
      ...CreatorDiscoveryEmailResourceFragment
    }
  }
  ${CREATOR_DISCOVERY_EMAIL_RESOURCE_FRAGMENT}
`;

export const CREATOR_DISCOVERY_INSTAGRAM_ACCOUNT_FRAGMENT = gql`
  fragment CreatorDiscoveryInstagramAccountFragment on CreatorDiscoveryInstagramAccount {
    id
    username
    igUserId
  }
`;

export const CREATOR_DISCOVERY_INSTAGRAM_SETTINGS_FRAGMENT = gql`
  fragment CreatorDiscoveryInstagramSettingsFragment on CreatorDiscoveryInstagramSettings {
    accounts {
      ...CreatorDiscoveryInstagramAccountFragment
    }
  }
  ${CREATOR_DISCOVERY_INSTAGRAM_ACCOUNT_FRAGMENT}
`;

export const CREATOR_DISCOVERY_SETTINGS_FRAGMENT = gql`
  fragment CreatorDiscoverySettingsFragment on CreatorDiscoverySettings {
    email {
      ...CreatorDiscoveryEmailSettingsFragment
    }
    instagram {
      ...CreatorDiscoveryInstagramSettingsFragment
    }
  }
  ${CREATOR_DISCOVERY_EMAIL_SETTINGS_FRAGMENT}
  ${CREATOR_DISCOVERY_INSTAGRAM_SETTINGS_FRAGMENT}
`;
